// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "1dcf4a33e36c";
export const BUILD_VERSION_NUMBER = 5;
